import React, { useEffect, useState } from "react";
import ContactItem from "./ContactItem.tsx";
import PickerPromoIcon from "../PickerPromo/PickerPromoIcon.tsx";
import useShowPickerPromo from "../PickerPromo/hooks/useShowPickerPromo.ts";
import { getLocalStorage } from "utils/globalLocalStorage.js";
import { useUser } from "contexts/userContext/userContext.js";

export const ContactsCircle = ({ drag }) => {
  const {
    getUserData,
    isLoggedIn,
    fetchContactList,
    getContactList,
    setContactList,
  } = useUser();

  const [notLoggedCirclesAmount, setNotLoggedCirclesAmount] = useState(1);

  const { showPickerPromo, isPickerUser } = useShowPickerPromo();

  const contactList = getContactList();

  useEffect(() => {
    setContactList(false);
    if (getUserData().UserId) {
      fetchContactList();
    } else {
      const localStorageMailsString = getLocalStorage("mailsList");
      const localStorageMailsArray = localStorageMailsString
        ? localStorageMailsString.split(",")
        : [];
      setTimeout(() => {
        setContactList(localStorageMailsArray);
      }, 300);
    }
  }, [getUserData().UserId]);

  const toggleShownCirclesAmount = (modalHidden) => {
    setNotLoggedCirclesAmount(() => (!modalHidden ? 6 : 1));
  };

  // create an array from 1 to 5 only after contactList is set to avoid errors
  const arr =
    contactList !== false
      ? [...Array(isLoggedIn() ? 5 : notLoggedCirclesAmount).keys()]
      : [];

  return !isLoggedIn() ? (
    <div className="contacts-circle">
      {arr.map((index) => (
        <React.Fragment key={index}>
          {(index === 0 || !index) && showPickerPromo ? (
            <PickerPromoIcon />
          ) : null}
          {!index ? (
            <ContactItem
              index={index}
              settingItem={true}
              empty={true}
              settingsClickCallback={
                !isLoggedIn() ? toggleShownCirclesAmount : null
              }
            />
          ) : (
            <ContactItem
              {...{
                item: contactList[index],
                drag,
                index,
                empty: !contactList[index],
                onContactAdded: fetchContactList,
              }}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  ) : (
    <div className="contacts-circle">
      {arr.map((index) => (
        <React.Fragment key={index}>
          {index === 0 && showPickerPromo ? (
            <PickerPromoIcon isPickerUser={isPickerUser} />
          ) : null}
          <ContactItem
            {...{
              item: contactList[index],
              drag,
              empty: !contactList[index],
              onContactAdded: fetchContactList,
              showPromo: showPickerPromo,
              index,
            }}
          />
          {index === arr.length - 1 ? (
            <ContactItem index={arr.length} settingItem={true} empty={true} />
          ) : null}
        </React.Fragment>
      ))}
    </div>
  );
};
